import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=94490170&scoped=true&"
import script from "./newPage.vue?vue&type=script&lang=js&"
export * from "./newPage.vue?vue&type=script&lang=js&"
import style0 from "./newPage.vue?vue&type=style&index=0&id=94490170&lang=scss&scoped=true&"
import style1 from "./newPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94490170",
  null
  
)

export default component.exports